/* eslint-disable no-return-assign */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/destructuring-assignment */
import { Box, Grid, MenuItem, TextField } from '@material-ui/core';
import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { polyfill } from 'react-lifecycles-compat';
import LinkField from '../Common/LinkField';

let fieldStateArray;
let customFieldListArray;

class CustomField extends Component {
  constructor(props) {
    super(props);
    customFieldListArray = [];
    this.state = {
      fieldsArray: null,
      withError: false,
      customFields: [],
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.customFields !== this.props.customFields ||
      prevProps.contactData.attributes !== this.props.contactData.attributes
    ) {
      this.updateCustomFields();
    }
  }

  componentDidMount() {
    this.props.onRef.current = this;
    this.updateCustomFields();
  }

  updateCustomFields = () => {
    const contactAttr =
      this.props.contactData && this.props.contactData.attributes;

    const { customFields = [], onChangeCustomContactFormField } = this.props;
    fieldStateArray = [];

    customFields?.forEach(item => {
      const { name } = item;

      const error = `${name}_error`;

      if (item.activated) {
        fieldStateArray.push(item);

        if (
          this.props.editContactFlg &&
          contactAttr &&
          contactAttr.length > 0
        ) {
          // to set values to custom fields
          contactAttr.forEach((data, innerKey) => {
            if (item.id === data.attrId) {
              item.value = data.value;
              contactAttr.splice(innerKey, 1);
            }
          });
        }

        this.setState({ [name]: item.value, [error]: '' });

        onChangeCustomContactFormField(item.id, item.value);

        item.possibleValues.forEach(data => {
          this.setState({ [data]: data });
        });
      }
    });

    this.setState(
      {
        fieldsArray: { status: true, success: fieldStateArray },
      },
      this.validateAllCustomFields
    );
  };

  handleSelectFieldChanged = (id, value, name, index) => {
    const { onChangeCustomContactFormField } = this.props;
    fieldStateArray[index].value = value;

    this.setState({ [name]: value }, this.validateAllCustomFields);
    onChangeCustomContactFormField(id, value);
  };

  handleTextFieldChanged = e => {
    const { onChangeCustomContactFormField } = this.props;

    const stateName = e.target.name;
    const key = e.target.id;

    this.setState(
      { [stateName]: e.target.value },
      this.validateAllCustomFields
    );

    const [attrId] = key.split('-');
    onChangeCustomContactFormField(attrId, e.target.value);
  };

  validateAllCustomFields = () => {
    let withError = false;

    fieldStateArray.forEach((item, index) => {
      //check if at least there is one validation error
      if (!withError) {
        withError = this.validateField(index);
      }
    });

    this.props.notifyError(withError);
  };

  validateField = index => {
    const fieldName = fieldStateArray[index];
    const stateName = `${fieldStateArray[index].name}_error`;
    let errorMessage = '';
    let withError = false;

    if (fieldName.required && !fieldName.value) {
      errorMessage = (
        <FormattedMessage
          id="ContactCustomField.requiredValidation"
          defaultMessage="Error"
        />
      );
      withError = true;
      // eslint-disable-next-line no-restricted-globals
    } else if (fieldName.type === 'NUMERIC' && isNaN(fieldName.value)) {
      errorMessage = (
        <FormattedMessage
          id="ContactCustomField.numberValidation"
          defaultMessage="Error"
        />
      );
      withError = true;
    } else {
      errorMessage = '';
    }

    this.setState({ [stateName]: errorMessage });

    return withError;
  };

  // this will create the custom field object and send it
  sendFieldDetail = () => {
    const attributes = [];
    if (fieldStateArray) {
      fieldStateArray.forEach((item, index) => {
        this.validateField(index);
        if (item.activated) {
          attributes.push({
            attrId: item.id,
            value: item.value ? item.value : null,
          });
        }
      });
    }

    return attributes;
  };

  renderCustomFields = () => {
    if (this.state.fieldsArray.status) {
      customFieldListArray = [];

      if (this.state.fieldsArray.success.length > 0) {
        this.state.fieldsArray.success.forEach((item, key) => {
          const stateName = item.name;
          const error = `${item.name}_error`;

          if (
            item.activated &&
            item.type === 'LIST' &&
            item.possibleValues.length > 0
          ) {
            const listArray = [];

            //allow no selection from list
            listArray.push({ value: null, text: '' });

            //handles when a current value is not present in possible values
            //(a possible value was removed from fields settings)
            const currentValue = this.state[stateName];
            const found = item.possibleValues.find(
              element => element === currentValue
            );

            if (!found && currentValue !== null && currentValue !== '') {
              listArray.push({
                value: this.state[stateName],
                text: this.state[stateName],
              });
            }

            item.possibleValues.forEach(data => {
              listArray.push({ value: data, text: data });
            });

            const currentDropdown = key;
            const options = listArray.sort((a, b) => {
              if (a.text?.toLowerCase() <= b.text?.toLowerCase()) return -1;
              return 1;
            });
            customFieldListArray.push(
              <TextField
                select
                fullWidth
                key={item.id}
                name={item.name}
                label={item.name}
                value={this.state[stateName]}
                error={this.state[error]}
                helperText={this.state[error]}
                onChange={({ target }) =>
                  this.handleSelectFieldChanged(
                    item.id,
                    target.value,
                    stateName,
                    currentDropdown
                  )
                }
                autoComplete="off"
              >
                {options.map(
                  ({ value, text }) =>
                    value && (
                      <MenuItem key={`mi-${value}`} value={value}>
                        {text}
                      </MenuItem>
                    )
                )}
              </TextField>
            );
          } else if (item.activated && item.type === 'LARGE_TEXT') {
            customFieldListArray.push(
              <TextField
                fullWidth
                key={item.id}
                name={item.name}
                className="muiTextField"
                maxLength={200}
                id={`${item.id}-${key}`}
                multiline
                value={this.state[stateName] ? this.state[stateName] : ''}
                ref={el => (this.fullNameDomElem = el)}
                label={item.name}
                error={this.state[error]}
                helperText={this.state[error]}
                onChange={this.handleTextFieldChanged}
                autoComplete="off"
              />
            );
          } else if (item.activated && item.type === 'SHORT_TEXT') {
            customFieldListArray.push(
              <LinkField
                fullWidth
                key={item.id}
                name={item.name}
                className="muiTextField"
                id={`${item.id}-${key}`}
                maxLength={200}
                value={this.state[stateName] ? this.state[stateName] : ''}
                ref={el => (this.fullNameDomElem = el)}
                label={item.name}
                error={this.state[error]}
                helperText={this.state[error]}
                onChange={this.handleTextFieldChanged}
              />
            );
          } else if (item.activated && item.type === 'NUMERIC') {
            customFieldListArray.push(
              <TextField
                fullWidth
                key={item.id}
                name={item.name}
                className="muiTextField"
                maxLength={200}
                value={this.state[stateName] ? this.state[stateName] : ''}
                ref={el => (this.fullNameDomElem = el)}
                id={`${item.id}-${key}`}
                label={item.name}
                error={this.state[error]}
                helperText={this.state[error]}
                onChange={this.handleTextFieldChanged}
                autoComplete="off"
              />
            );
          }
        });
      } else if (this.state.fieldsArray.success.length > 0) {
        const customFieldsLink = (
          <div key="customFieldsLoading" id="customFieldsLoadingId">
            Loading...
          </div>
        );

        customFieldListArray.push(customFieldsLink);
      }
    }
  };

  render() {
    return (
      <Box>
        {this.state.fieldsArray ? this.renderCustomFields() : ''}
        <Grid container spacing={2}>
          {customFieldListArray.map(customField => (
            <Grid item xs={12} key={`grid-${customField.key}`}>
              {customField}
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }
}

polyfill(CustomField);

export default injectIntl(CustomField);
